export default {
    nl: {
        intro: {
            subtitle: 'UX/UI design',
            title: 'Bezoekers de wegwijzen.',
            contact: 'Neem contact op',
            image: 'https://23g-website.s3.eu-central-1.amazonaws.com/services/ux/hero.jpg',
        },
        type: 'UX/UI design',
        title: 'UI/UX Design: optimale & intuïtieve digitale ervaring',
        description:
            'Creëer aantrekkelijke en gebruiksvriendelijke digitale producten met ons UI/UX Design. Ons team combineert functionaliteit en design!',
        content: [
            {
                type: 'text',
                title: 'UX/UI Design',
                content:
                    'Wij weten als geen ander hoe belangrijk een optimale gebruikerservaring is in combinatie met de kracht van aantrekkelijk visual design. Dit noemen we UI/UX Design. Ons doel is simpel: je digitale producten en diensten naar een hoger niveau tillen met een slim en intuïtief ontwerp.',
            },
            {
                type: 'images',
                images: [
                    'https://23g-website.s3.eu-central-1.amazonaws.com/services/app-wireframe.png',
                    'https://23g-website.s3.eu-central-1.amazonaws.com/services/app-finished.png',
                ],
            },
            {
                type: 'text',
                title: 'Wat doen UX/UI designers?',
                content: `
                    Een goed eindproduct draait niet alleen om de looks, maar ook om de functionaliteiten en gebruiksvriendelijkheid. Gebruikerservaring (UX) gaat hand in hand met het gebruikersinterface (UI). Met UX-design leggen we de basis met behulp van de uitkomsten van een gebruikersonderzoek (UX research). Hier ontwerpen we de juiste gebruikerservaring, waarbij de focus ligt op de behoeften en verwachtingen van de eindgebruiker met een responsive design. Dit doen we met behulp van wireframing en prototyping.
                    <br><br>
                    Bij UI ligt de focus op de visuele interactieve elementen van een digitaal product. Hier speelt de look and feel een grotere rol, inclusief de uitstraling, leesbaarheid en toegankelijkheid van de kleuren.
                `,
            },
            {
                type: 'quote',
                content:
                    'Er zitten meer haken en ogen aan een mooi ontwerp dan je je in eerste instantie kunt voorstellen.',
            },
            {
                type: 'text',
                title: 'Ons ontwerpproces',
                content: `
                    Over toegankelijkheid gesproken. Er zitten meer haken en ogen aan een mooi ontwerp dan je je in eerste instantie kunt voorstellen. We willen dat iedereen van onze mooie ontwerpen geniet. Daarom integreren we toegankelijkheid in ons ontwerp- en ontwikkelproces. Dit betekent dat we speciale aandacht besteden aan aspecten zoals de juiste kleurcontrasten en de grootte van lettertypes, om zo een inclusieve gebruikerservaring te garanderen. Op die manier maken alle gebruikers optimaal gebruik van jouw product, ook degenen die leven met beperkingen of een handicap.
                    <br><br>
                    Dit alles doen we in nauwe samenwerking met onze klant en zijn eindgebruikers. We starten een ontwerpproces het liefst met een Design Sprint, waarbij we luisteren naar jouw visie, feedback en ideeën. Vervolgens combineren we alle verzamelde inzichten met onze expertise om zo tot een optimaal en aansprekend minimum viable product (MVP) te komen. Dit is een initiële versie van het product, voorzien van enkel essentiële functies. Deze versie kan dan door gebruik van klanten worden getest. Feedback uit deze fase helpt met de verdere ontwikkeling van het product.
                `,
            },
            {
                type: 'image-big',
                image: 'https://23g-website.s3.eu-central-1.amazonaws.com/services/meeting-group-board.webp',
            },
        ],
        related_services: ['wireframing-prototyping', 'ux-research', 'design-sprint'],
        contact: {
            title: '',
            employee: 'jack',
        },
    },
    en: {},
};
